angular.module('lead')
    .factory('LeadConsent', function ($resource) {
        return $resource('/crm/api/lead-consent/:id', {id: '@id'}, {
            query: {method: 'GET', isArray: true},
            table: {method: 'GET', isArray: false, url: '/crm/api/lead-consent/table'},
            save: {method: 'POST'},
            remove: {method: 'DELETE'}
        });
    })
    .service('LeadConsentListService', function ($rootScope, modals, LeadConsent) {
        this.add = () => modals.open('app/lead/consent/edit-modal.html', 'LeadConsentEditModalController', {}, {size: 'md'}, '$ctrl')
            .then(() => $rootScope.$broadcast('lead.consent.updated'));

        this.delete = item => modals.confirmDelete('zgodę ' + item.id, () => LeadConsent.remove({id: item.id}).$promise.then(() => {
            $rootScope.$broadcast('lead.consent.updated');
        }));

        this.showAllForContact = item => {
            if (!item || !item.contact) {
                return;
            }
            return modals.open('app/lead/consent/all-modal.html', 'LeadConsentAllModalController', {
                contact: item.contact
            }, {size: 'lg'}, '$ctrl');
        };
    })
    .component('leadConsentManager', {
        bindings: {
            lead: '<',
            client: '<',
            contact: '<',
            contacts: '<',
            readonly: '<',
            compact: '<',
            noHeader: '<',
            allContacts: '<',
            contactHistoryAllLeads: '<',
            noForm: '<',
            draftConsents: '=',
            onDataLoaded: '&',
            onVisibilityChange: '&'
        },
        templateUrl: 'app/lead/consent/manager.html',
        controller: function ($rootScope, toastr, modals, LeadConsent, LeadService) {
            this.channels = ['EMAIL', 'PHONE', 'SMS', 'OTHER'];
            this.purposes = ['MARKETING', 'DATA_PROCESSING_INFO_ACK', 'PRIVACY_POLICY_ACK'];
            this.statuses = ['GRANTED', 'WITHDRAWN'];
            this.draftSequence = 0;
            this.draftHistoryRequestId = 0;
            this.historyItems = [];
            this.currentItems = [];
            this.currentGroupedItems = [];
            this.expandedConsentGroups = {};

            this.lookupClient = () => this.lead?.client || this.client;

            this.hasLookupContacts = () => this.collectContacts(this.lookupClient()).length > 0;

            this.$onChanges = () => {
                if (this.isDraftMode()) {
                    this.initDraftMode();
                    return;
                }
                if (this.contact) {
                    this.reload();
                    this.resetForm();
                    return;
                }
                if (this.lead && this.lead.id) {
                    this.reload();
                    this.resetForm();
                    return;
                }
                if (this.client && this.client.id) {
                    this.reload();
                    this.resetForm();
                    return;
                }
                if (this.hasLookupContacts()) {
                    this.reload();
                    this.resetForm();
                }
            };

            this.isDraftMode = () => !this.lead?.id && angular.isArray(this.draftConsents);

            this.initDraftMode = () => {
                const requestId = ++this.draftHistoryRequestId;
                const contacts = this.collectContacts(this.lookupClient());
                this.historyItems = [];
                this.loading = false;
                this.itemsPromise = null;
                this.refreshDraftItems();
                this.resetForm();

                if (!contacts.length) {
                    this.notifyDataLoaded();
                    this.notifyVisibility();
                    return;
                }

                this.loading = true;
                this.itemsPromise = LeadConsent.query({contacts: contacts, includeLeadConsents: true}).$promise;
                return this.itemsPromise
                    .then(items => {
                        if (requestId !== this.draftHistoryRequestId) {
                            return;
                        }
                        this.historyItems = items || [];
                        this.refreshDraftItems();
                    })
                    .finally(() => {
                        if (requestId !== this.draftHistoryRequestId) {
                            return;
                        }
                        this.loading = false;
                        this.notifyDataLoaded();
                        this.notifyVisibility();
                    });
            };

            this.refreshDraftItems = () => {
                const draftItems = this.draftConsents || [];
                this.items = this.sortItems(draftItems.concat(this.filterItemsByLookupContacts(this.historyItems || [])));
            };

            this.reload = () => {
                this.loading = true;
                this.itemsPromise = LeadConsent.query(this.buildReloadParams()).$promise;
                return this.itemsPromise
                    .then(items => this.items = this.sortItems(this.filterItemsByLookupContacts(items || [])))
                    .finally(() => {
                        this.loading = false;
                        this.notifyDataLoaded();
                        this.notifyVisibility();
                    });
            };

            this.buildReloadParams = () => {
                if (this.contact) {
                    return {contact: this.contact};
                }

                const client = this.lookupClient();
                const contacts = this.collectContacts(client);

                if (this.allContacts) {
                    if (this.contactHistoryAllLeads && contacts.length) {
                        return {contacts: contacts, includeLeadConsents: true};
                    }
                    if (this.lead?.id) {
                        return {leadId: this.lead.id};
                    }
                    return {contacts: contacts, includeLeadConsents: true};
                }

                if (this.lead?.id) {
                    return {leadId: this.lead.id, contacts: contacts};
                }

                return {contacts: contacts, includeLeadConsents: !!this.client?.id};
            };

            this.collectContacts = client => {
                const contacts = [];
                const seen = {};
                const addContactValue = value => {
                    const key = String(value || '').trim().toLowerCase();
                    if (key && !seen[key]) {
                        seen[key] = true;
                        contacts.push(value);
                    }
                };

                (angular.isArray(this.contacts) ? this.contacts : [this.contacts])
                    .filter(Boolean)
                    .forEach(addContactValue);

                addContactValue(this.lead?.sourcePhone);
                addContactValue(this.lead?.sourceEmail);

                (client?.contacts || []).forEach(contact => {
                    if (!this.isPhoneOrEmailContact(contact)) {
                        return;
                    }
                    addContactValue(contact.value);
                });

                return contacts;
            };

            this.isPhoneOrEmailContact = contact => contact
                && contact.active !== false
                && contact.value
                && (!contact.type || contact.type === 'EMAIL' || contact.type === 'PHONE');

            this.sortItems = items => {
                const sorted = this.allContacts ? (items || []).slice() : (items || []).slice().sort(this.compareByPurposeAndContact);
                this.groupedItems = this.groupItemsByPurpose(sorted);
                this.currentItems = this.buildCurrentItems(sorted);
                this.currentGroupedItems = this.groupItemsByPurpose(this.currentItems);
                return sorted;
            };

            this.groupItemsByPurpose = items => {
                const groups = [];
                const byPurpose = {};
                items.forEach(item => {
                    const purpose = item?.purpose || 'OTHER';
                    if (!byPurpose[purpose]) {
                        byPurpose[purpose] = {
                            purpose: purpose,
                            items: [],
                            channels: [],
                            grantedCount: 0,
                            withdrawnCount: 0
                        };
                        groups.push(byPurpose[purpose]);
                    }
                    byPurpose[purpose].items.push(item);
                    if (item?.status === 'WITHDRAWN') {
                        byPurpose[purpose].withdrawnCount++;
                    } else {
                        byPurpose[purpose].grantedCount++;
                    }
                    if (item?.channel && byPurpose[purpose].channels.indexOf(item.channel) < 0) {
                        byPurpose[purpose].channels.push(item.channel);
                    }
                });
                groups.forEach(group => group.channels.sort((a, b) => this.compareText(a, b)));
                return groups;
            };

            this.buildCurrentItems = items => {
                const currentByKey = {};
                (items || []).forEach(item => {
                    const key = this.currentConsentKey(item);
                    if (!key) {
                        return;
                    }
                    if (!currentByKey[key] || this.compareByDateDesc(item, currentByKey[key]) < 0) {
                        currentByKey[key] = item;
                    }
                });
                return Object.keys(currentByKey)
                    .map(key => currentByKey[key])
                    .sort(this.compareByPurposeAndContact);
            };

            this.currentConsentKey = item => {
                if (!item) {
                    return null;
                }
                return [
                    this.currentConsentContactKey(item),
                    item.channel || '',
                    item.purpose || ''
                ].join('|');
            };

            this.currentConsentContactKey = item => {
                const contact = String(item?.contact || '').trim();
                if (!contact) {
                    return '';
                }
                if (item?.channel === 'EMAIL' || contact.indexOf('@') >= 0) {
                    return contact.toLowerCase();
                }
                if (item?.channel === 'PHONE' || item?.channel === 'SMS') {
                    return this.canonicalPhoneKey(contact);
                }
                return contact.toLowerCase();
            };

            this.canonicalPhoneKey = value => {
                const digits = String(value || '').replace(/\D/g, '');
                if (digits.indexOf('0048') === 0 && digits.length === 13) {
                    return digits.slice(4);
                }
                if (digits.indexOf('48') === 0 && digits.length === 11) {
                    return digits.slice(2);
                }
                return digits || String(value || '').trim().toLowerCase();
            };

            this.filterItemsByLookupContacts = items => {
                if (!this.shouldRestrictToLookupContacts()) {
                    return items || [];
                }
                const lookup = this.buildContactLookup(this.collectContacts(this.lookupClient()));
                if (!lookup.hasValues) {
                    return items || [];
                }
                return (items || []).filter(item => this.matchesContactLookup(item, lookup));
            };

            this.shouldRestrictToLookupContacts = () => this.hasLookupContacts()
                && (this.contactHistoryAllLeads || !this.lookupClient()?.id);

            this.buildContactLookup = contacts => {
                const lookup = {
                    emails: {},
                    phones: {},
                    others: {},
                    hasValues: false
                };
                (contacts || []).forEach(contact => {
                    const value = String(contact || '').trim();
                    if (!value) {
                        return;
                    }
                    lookup.hasValues = true;
                    if (value.indexOf('@') >= 0) {
                        lookup.emails[value.toLowerCase()] = true;
                        return;
                    }
                    const phoneKeys = this.phoneSearchKeys(value);
                    if (phoneKeys.length > 0) {
                        phoneKeys.forEach(key => lookup.phones[key] = true);
                        return;
                    }
                    lookup.others[value.toLowerCase()] = true;
                });
                return lookup;
            };

            this.matchesContactLookup = (item, lookup) => {
                const contact = String(item?.contact || '').trim();
                if (!contact) {
                    return false;
                }
                if (item?.channel === 'EMAIL' || contact.indexOf('@') >= 0) {
                    return !!lookup.emails[contact.toLowerCase()];
                }
                if (item?.channel === 'PHONE' || item?.channel === 'SMS') {
                    return this.phoneSearchKeys(contact).some(key => lookup.phones[key]);
                }
                return !!lookup.others[contact.toLowerCase()];
            };

            this.phoneSearchKeys = value => {
                const digits = String(value || '').replace(/\D/g, '');
                if (digits.length < 7) {
                    return [];
                }
                const keys = {};
                const add = key => {
                    if (key && key.length >= 7) {
                        keys[key] = true;
                    }
                };
                add(digits);
                if (digits.indexOf('0048') === 0 && digits.length === 13) {
                    add(digits.slice(4));
                    add(digits.slice(2));
                } else if (digits.indexOf('48') === 0 && digits.length === 11) {
                    add(digits.slice(2));
                } else if (digits.length === 9) {
                    add('48' + digits);
                }
                return Object.keys(keys);
            };

            this.toggleConsentGroup = purpose => this.expandedConsentGroups[purpose] = !this.expandedConsentGroups[purpose];

            this.isConsentGroupExpanded = purpose => !!this.expandedConsentGroups[purpose];

            this.compareByPurposeAndContact = (a, b) => {
                const typeCompare = this.compareText(a?.purpose, b?.purpose);
                if (typeCompare !== 0) {
                    return typeCompare;
                }

                const contactCompare = this.compareText(a?.contact, b?.contact);
                if (contactCompare !== 0) {
                    return contactCompare;
                }

                const channelCompare = this.compareText(a?.channel, b?.channel);
                if (channelCompare !== 0) {
                    return channelCompare;
                }

                return this.compareByDateDesc(a, b);
            };

            this.compareText = (a, b) => String(a || '').trim().toLowerCase().localeCompare(String(b || '').trim().toLowerCase(), 'pl');

            this.compareByDateDesc = (a, b) => {
                const dateA = this.itemDate(a);
                const dateB = this.itemDate(b);

                if (dateA === dateB) {
                    return this.itemOrder(b) - this.itemOrder(a);
                }
                if (!dateA) {
                    return 1;
                }
                if (!dateB) {
                    return -1;
                }
                return dateB - dateA;
            };

            this.itemOrder = item => {
                if (angular.isNumber(item?.draftOrder)) {
                    return item.draftOrder;
                }
                return angular.isNumber(item?.id) ? item.id : 0;
            };

            this.itemDate = item => {
                const value = item?.withdrawnAt || item?.grantedAt || item?.createdTime;
                return value ? new Date(value).getTime() : null;
            };

            this.resetForm = () => {
                const leadClient = this.lead?.client;
                const client = leadClient || this.client;
                this.form = {
                    leadId: this.lead?.id,
                    channel: 'EMAIL',
                    purpose: 'MARKETING',
                    status: 'GRANTED',
                    contact: this.firstContactValue(client, 'EMAIL'),
                    gdprSourceId: null,
                    withdrawalMethodId: null
                };
            };

            this.onChannelChange = () => {
                const client = this.lead?.client || this.client;
                if (this.form.channel === 'EMAIL') {
                    this.form.contact = this.firstContactValue(client, 'EMAIL');
                } else if (this.form.channel === 'PHONE' || this.form.channel === 'SMS') {
                    this.form.contact = this.firstContactValue(client, 'PHONE');
                } else {
                    this.form.contact = null;
                    this.form.purpose = 'DATA_PROCESSING_INFO_ACK';
                }
            };

            this.firstContactValue = (client, type) => {
                const contact = (client?.contacts || []).find(item => item && item.active !== false && item.type === type && item.value);
                return contact ? contact.value : null;
            };

            this.save = () => {
                const payload = angular.copy(this.form);
                payload.gdprSourceId = payload.gdprSource?.id || null;
                payload.withdrawalMethodId = payload.withdrawalMethod?.id || null;
                delete payload.gdprSource;
                delete payload.withdrawalMethod;
                if (this.isDraftMode()) {
                    payload.draftOrder = Date.now();
                    payload.id = 'draft-' + Date.now() + '-' + (++this.draftSequence);
                    payload.grantedAt = payload.status === 'GRANTED' ? new Date() : null;
                    payload.withdrawnAt = payload.status === 'WITHDRAWN' ? new Date() : null;
                    this.draftConsents.push(payload);
                    this.refreshDraftItems();
                    this.resetForm();
                    return;
                }
                return LeadConsent.save(payload).$promise.then(() => {
                    toastr.success('Zapisano zgodę');
                    $rootScope.$broadcast('lead.consent.updated');
                    this.reload();
                    this.resetForm();
                });
            };

            this.removeDraft = item => {
                if (!this.isDraftMode()) {
                    return;
                }
                const index = this.draftConsents.indexOf(item);
                if (index >= 0) {
                    this.draftConsents.splice(index, 1);
                    this.refreshDraftItems();
                }
            };

            this.showManage = () => modals.open('app/lead/consent/manage-modal.html', 'LeadConsentManageModalController', {
                lead: this.lead,
                client: this.lookupClient(),
                contacts: this.collectContacts(this.lookupClient()),
                draftConsents: this.draftConsents
            }, {size: 'lg'}, '$ctrl').finally(() => {
                if (this.isDraftMode()) {
                    this.initDraftMode();
                    return;
                }
                if (this.lead?.id || this.client?.id) {
                    this.reload();
                }
            });

            this.showAll = () => modals.open('app/lead/consent/all-modal.html', 'LeadConsentAllModalController', {
                lead: this.lead,
                client: this.lookupClient(),
                contacts: this.collectContacts(null)
            }, {size: 'lg'}, '$ctrl');

            this.showLead = leadId => {
                if (leadId) {
                    LeadService.show(leadId);
                }
            };

            this.showLeadColumn = () => this.allContacts;

            this.showDraftColumn = () => this.isDraftMode();

            this.isDraftConsent = item => this.isDraftMode() && this.draftConsents && this.draftConsents.indexOf(item) >= 0;

            this.canShowHistory = () => (this.lead && this.lead.id) || this.hasLookupContacts();

            this.fullTableColspan = () => 7 + (this.showLeadColumn() ? 1 : 0) + (this.showDraftColumn() ? 1 : 0);

            this.showFullTable = () => !this.compact && (this.allContacts || this.isDraftMode() || this.loading || !this.client || !this.client.id || (this.items && this.items.length > 0));

            this.showManager = () => this.contact
                || (this.lead && this.lead.id)
                || this.allContacts
                || this.isDraftMode()
                || (!this.client || !this.client.id)
                || this.loading
                || (this.items && this.items.length > 0)
                || !this.readonly;

            this.notifyVisibility = () => {
                if (this.onVisibilityChange) {
                    this.onVisibilityChange({visible: this.showManager()});
                }
            };

            this.notifyDataLoaded = () => {
                if (this.onDataLoaded) {
                    this.onDataLoaded({$items: this.items || []});
                }
            };

            this.emptyMessage = () => {
                if (this.isDraftMode()) {
                    if (this.hasLookupContacts()) {
                        return 'Brak zgód do zapisania ani historii zgód dla danych kontaktowych';
                    }
                    return 'Brak zgód do zapisania z leadem';
                }
                if (this.allContacts || this.contact) {
                    return 'Brak historii zgód kontaktowych';
                }
                return 'Brak zgód kontaktowych leada';
            };

            this.manageButtonTooltip = () => this.isDraftMode()
                ? 'Dodaj zgodę do tworzonego leada'
                : 'Dodaj zgodę do leada';

            this.isContactRequired = () => this.form && this.form.channel !== 'OTHER';

            this.channelIcon = channel => {
                if (channel === 'EMAIL') {
                    return 'fa-envelope-o';
                }
                if (channel === 'PHONE') {
                    return 'fa-phone';
                }
                if (channel === 'SMS') {
                    return 'fa-mobile-phone';
                }
                return 'fa-info-circle';
            };

            this.purposeIcon = purpose => {
                if (purpose === 'MARKETING') {
                    return 'fa-bullhorn';
                }
                if (purpose === 'PRIVACY_POLICY_ACK') {
                    return 'fa-shield';
                }
                if (purpose === 'DATA_PROCESSING_INFO_ACK') {
                    return 'fa-database';
                }
                return 'fa-check-square-o';
            };

            this.statusIcon = status => status === 'WITHDRAWN' ? 'fa-ban' : 'fa-check';
        }
    })
    .component('leadConsentList', {
        bindings: {
            filters: '<',
            page: '<'
        },
        templateUrl: 'app/lead/consent/list.html',
        controller: function ($scope, $httpParamSerializer, $state, $stateParams, LeadConsentListService, LeadService) {
            this.LeadService = LeadService;
            this.LeadConsentListService = LeadConsentListService;
            this.channels = ['EMAIL', 'PHONE', 'SMS', 'OTHER'];
            this.purposes = ['MARKETING', 'DATA_PROCESSING_INFO_ACK', 'PRIVACY_POLICY_ACK'];
            this.statuses = ['GRANTED', 'WITHDRAWN'];

            this.$onInit = () => this.prepareItems();

            this.$onChanges = () => this.prepareItems();

            this.prepareItems = () => {
                (this.page?.list || []).forEach(item => {
                    item.effectiveDateValue = this.effectiveDate(item);
                });
            };

            this.reset = () => this.filters = {};

            this.channelIcon = channel => {
                if (channel === 'EMAIL') {
                    return 'fa-envelope-o';
                }
                if (channel === 'PHONE') {
                    return 'fa-phone';
                }
                if (channel === 'SMS') {
                    return 'fa-mobile-phone';
                }
                return 'fa-info-circle';
            };

            this.statusClass = status => status === 'WITHDRAWN' ? 'label-danger' : 'label-success';

            this.statusIcon = status => status === 'WITHDRAWN' ? 'fa-ban' : 'fa-check';

            this.purposeIcon = purpose => {
                if (purpose === 'MARKETING') {
                    return 'fa-bullhorn';
                }
                if (purpose === 'PRIVACY_POLICY_ACK') {
                    return 'fa-shield';
                }
                if (purpose === 'DATA_PROCESSING_INFO_ACK') {
                    return 'fa-database';
                }
                return 'fa-check-square-o';
            };

            this.effectiveDate = item => {
                if (!item) {
                    return null;
                }
                if (item.status === 'WITHDRAWN') {
                    return item.withdrawnAt || item.effectiveAt || item.createdTime;
                }
                return item.grantedAt || item.effectiveAt || item.createdTime;
            };

            this.add = () => LeadConsentListService.add();

            this.getExportUrl = params => {
                const paramsAll = angular.copy(this.filters || $stateParams);
                angular.extend(paramsAll, params);
                return '/crm/api/lead-consent-batch/export?' + $httpParamSerializer(paramsAll);
            };

            this.getCurrentExportUrl = params => {
                const paramsAll = angular.copy(this.filters || $stateParams);
                angular.extend(paramsAll, params);
                return '/crm/api/lead-consent-batch/export-current?' + $httpParamSerializer(paramsAll);
            };

            $scope.$on('lead.consent.updated', () => $state.reload());
        }
    })
    .component('leadConsentBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/lead/consent/_btn-options.html',
        controller: function (LeadConsentListService) {
            this.LeadConsentListService = LeadConsentListService;

            this.showAllForContact = () => LeadConsentListService.showAllForContact(this.item);

            this.delete = () => LeadConsentListService.delete(this.item);
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('leadConsentList', {
            parent: 'app',
            url: '/lead-consent?{page:int}&{size:int}&sort&search&channel&purpose&status&createdStart&createdEnd',
            data: {
                authorities: ['ROLE_LEADS']
            },
            views: {
                'content@': 'leadConsentList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (LeadConsent, $stateParams) => LeadConsent.table(angular.copy($stateParams)).$promise
            }
        });
    })
    .controller('LeadConsentAllModalController', function ($uibModalInstance, data) {
        this.lead = data?.lead;
        this.client = data?.client || this.lead?.client;
        this.contact = data?.contact;
        this.contacts = collectModalContacts(this.lead, data?.contacts);
        this.showAllContactConsents = false;
        this.hasContacts = () => this.contacts.length > 0;
        this.canShowAllContactsFilter = () => this.lead?.id && this.hasContacts();
        this.title = () => {
            if (this.contact) {
                return 'Historia zgód kontaktu';
            }
            if (this.lead?.id) {
                return 'Historia zgód kontaktowych leada #' + this.lead.id;
            }
            return 'Historia zgód kontaktowych';
        };
        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        function collectModalContacts(lead, values) {
            const contacts = [];
            const seen = {};
            const addContactValue = value => {
                const key = String(value || '').trim().toLowerCase();
                if (key && !seen[key]) {
                    seen[key] = true;
                    contacts.push(value);
                }
            };

            (angular.isArray(values) ? values : [values])
                .filter(Boolean)
                .forEach(addContactValue);

            addContactValue(lead?.sourcePhone);
            addContactValue(lead?.sourceEmail);

            return contacts;
        }
    })
    .controller('LeadConsentManageModalController', function ($uibModalInstance, data) {
        this.lead = data?.lead;
        this.client = data?.client || this.lead?.client;
        this.contacts = data?.contacts;
        this.draftConsents = data?.draftConsents;
        this.title = () => this.lead?.id
            ? 'Dodaj / edytuj zgody leada #' + this.lead.id
            : 'Dodaj / edytuj zgody tworzonego leada';
        this.cancel = () => $uibModalInstance.close();
    })
    .controller('LeadConsentEditModalController', function ($uibModalInstance, data, LeadConsent) {
        this.channels = ['EMAIL', 'PHONE', 'SMS', 'OTHER'];
        this.purposes = ['MARKETING', 'DATA_PROCESSING_INFO_ACK', 'PRIVACY_POLICY_ACK'];
        this.statuses = ['GRANTED', 'WITHDRAWN'];
        this.item = angular.extend({
            channel: 'EMAIL',
            purpose: 'MARKETING',
            status: 'GRANTED'
        }, data || {});

        this.isContactRequired = () => this.item && this.item.channel !== 'OTHER';

        this.onChannelChange = () => {
            if (this.item.channel === 'OTHER') {
                this.item.contact = null;
            }
        };

        this.save = () => {
            const payload = angular.copy(this.item);
            payload.gdprSourceId = payload.gdprSource?.id || null;
            payload.withdrawalMethodId = payload.withdrawalMethod?.id || null;
            delete payload.gdprSource;
            delete payload.withdrawalMethod;

            return LeadConsent.save(payload).$promise.then(saved => $uibModalInstance.close(saved));
        };

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
    });
